import { ReactNode } from "react";

import { Button, Heading } from "@stellar/design-system";

import { SectionHeader } from "@/components/SectionHeader";

import "../styles.scss";

type ManageCoSigningProps = {
  /** The outcome of the last removal (cancelled, expired, failed), shown above the actions. */
  notice?: ReactNode;
  onBack: () => void;
  onTurnOff: () => void;
};

export const ManageCoSigning = ({ notice, onBack, onTurnOff }: ManageCoSigningProps) => (
  <div className="MultisigManage">
    <SectionHeader>
      <SectionHeader.Row>
        <SectionHeader.Content>
          <Heading as="h2" size="sm">
            Manage co-signing
          </Heading>
        </SectionHeader.Content>
      </SectionHeader.Row>
    </SectionHeader>
    {notice ? <div className="MultisigManage__error">{notice}</div> : null}
    <section className="MultisigManage__danger">
      <div>
        <h2 className="MultisigManage__h2">Turn off co-signing</h2>
        <p className="MultisigManage__p">
          Disbursements will only need one person&apos;s approval. Turning it off needs approval
          from both Owners.
        </p>
      </div>
      <Button variant="destructive" size="md" onClick={onTurnOff}>
        Turn off co-signing
      </Button>
    </section>
    <div className="MultisigManage__footer">
      <Button variant="tertiary" size="md" onClick={onBack}>
        ‹ Back
      </Button>
    </div>
  </div>
);
